import { render, staticRenderFns } from "./BadPhoto.vue?vue&type=template&id=04420d85&scoped=true"
import script from "./BadPhoto.vue?vue&type=script&lang=js"
export * from "./BadPhoto.vue?vue&type=script&lang=js"
import style0 from "./BadPhoto.vue?vue&type=style&index=0&id=04420d85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04420d85",
  null
  
)

export default component.exports